class VhCalc {
	constructor() {
        this.calulate();

        // We listen to the resize event
        window.addEventListener('resize', () => {
            this.calulate();
        });
	}
    calulate() {
        // Get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;

        // Set the value in the --vh custom variable to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
}

export default new VhCalc();
